import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { isSlashFirst } from '../../helpers/StringHelper';

class DetailMediaRelationship extends Component {

    generateMedia = (medias) => {
        return medias.map((media, index) => {
            let imgThumbnail = null;
            if (media.img) {
                if (media.img.includes('https://') || media.img.includes('http://')) {
                    imgThumbnail = media.img;
                } else {
                    imgThumbnail = isSlashFirst(media.img) ? media.img : '/' + media.img;
                }
            }
            return <React.Fragment key={index}>
                <div className="block">
                    <Link to={"/media/watch/" + media.id} >
                        <img src={imgThumbnail} className="img-responsive" alt={media.name} />
                        <div className="name">
                            <span>{media.name}</span>
                        </div>
                    </Link>
                </div>
            </React.Fragment>
        });
    }

    render() {
        if (this.props.mediaRelationship.loading) return 'DetailMediaRelationship loading...';
        if (this.props.mediaRelationship.error) return `DetailMediaRelationship Error: ${this.props.mediaRelationship.error.message}`;
        let medias = this.props.mediaRelationship.getMediaRelationship;
        if (!medias) return 'DetailMediaRelationship not found...';

        return (
            <React.Fragment>
                <h3 className="name">Phim khác</h3>
                <div className="unit-wrap clearfix">
                    {this.generateMedia(medias)}
                </div>
            </React.Fragment>
        )
    }
}

export default DetailMediaRelationship;



// WEBPACK FOOTER //
// ./src/components/DetailMediaPage/DetailMediaRelationship.js